import { render, staticRenderFns } from "./ReportRibbonsBalances.vue?vue&type=template&id=0b870afc"
import script from "./ReportRibbonsBalances.vue?vue&type=script&lang=js"
export * from "./ReportRibbonsBalances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports